import { FontWeight } from '@config/theme/sizes'
import { Stack, styled, SvgIconTypeMap, Typography } from '@mui/material'
import { OverridableComponent } from '@mui/material/OverridableComponent'
import { PropsWithChildren } from 'react'

type ChipsProps = {
	color: Record<number, string>
	EndAdornment?: OverridableComponent<SvgIconTypeMap>
	endAdornmentSize?: string
}

/**
 * Chip
 * @param backgroundColor
 * @param children
 * @param color
 * @param EndAdornment
 * @param endAdornmentSize
 * @constructor
 */
const Chip = (
	{
		children,
		color,
		EndAdornment,
		endAdornmentSize
	}: PropsWithChildren<ChipsProps>
) => {
	return (
		<Container
			sx={{
				backgroundColor: color[100]
			}}
		>
			<Typography color={color[700]} variant="subtitle2" fontWeight={FontWeight.MEDIUM}>
				{children}
			</Typography>
			{EndAdornment && (
				<EndAdornment
					sx={{
						height: endAdornmentSize,
						width: endAdornmentSize
					}}
				/>
			)}
		</Container>
	)
}

const Container = styled(Stack)({
	alignItems: 'center',
	borderRadius: '4px',
	columnGap: '8px',
	flexDirection: 'row',
	padding: '4px 8px'
})

export default Chip
